import { LitElement, html, css } from 'lit-element';
import { connect } from '../store/connect';
import { actions as siteActions, selectors } from '../site/';
import { FormElement } from './form-element-base';
import { OPTION_TYPES } from '../util/constants';
import '@trumedianetworks/tmn-core-components/src/tmn-tooltip';
import './form-element-select';
import './form-element-input';
import './form-element-checkbox';
import './form-element-domain';
import './form-element-auth-context';
import './form-element-rugby-competitions';
import './form-element-soccer-leagues';
import './form-element-cricket-leagues';
import '@trumedianetworks/tmn-core-components/src/tmn-button';

class FormElementSite extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-flow: row;
                    /* padding: 4px; */
                    /* margin-right: 20px; */
                    max-width: 400px;
                    position: relative;
                }
                :host > div > * {
                    padding: 4px;
                }
                :host > div > form-element-auth-context {
                    padding: 0;
                }
                :host([hasoverride]) {
                    background: #ffa50029;
                }
                :host([hasoverride]) > div {
                    align-items: center;
                }
                :host([hasoverride]) > div tmn-icon-button {
                    margin-left: 8px;
                }
                :host > div {
                    display: flex;
                    flex-flow: row;
                    flex: 1;
                }
                tmn-icon.info {
                    margin-left: 6px;
                    color: var(--app-primary-color);
                }
            `,
        ];
    }

    static get properties() {
        return {
            actions: {
                type: Object,
            },
            hasOverride: {
                type: Boolean,
                reflect: true,
            },
            overrideValue: {
                type: String,
            },
            guid: {
                type: String,
            },
            sport: {
                type: String,
            },
        };
    }

    firstUpdated() {}

    updated(changedProps) {
        super.updated(changedProps);
    }

    render() {
        if (this.itemTemplate?.type === OPTION_TYPES.META) {
            return null;
        }
        // wrapper div necessary to let tooltip work
        return html`<div>
            ${this.renderByType()} ${this.renderTooltip()}${this.renderOverrideDetail()}
        </div>`;
    }

    renderByType() {
        const {
            itemTemplate,
            path,
            detailMode,
            validationError,
            value,
            isDirty,
            isOverrideMode,
            hasPassedValidationCheck,
            actions,
            guid,
            sport,
        } = this;
        // slightly confusing, but this can be readonly (due to the path sites) at the template level
        // whereas isReadonly from above is inclusive of state of the app (i.e. edit/view)
        const isElementReadOnly = this?.isReadOnly || itemTemplate?.isReadOnly;
        // properties can be defined like this: commonURL: OPTION_TYPES.STRING,
        if (itemTemplate === OPTION_TYPES.STRING) {
            return html`<form-element-input
                .path=${path}
                .detailMode=${detailMode}
                .isOverrideMode=${isOverrideMode}
                .itemTemplate=${itemTemplate}
                .hasPassedValidationCheck=${hasPassedValidationCheck}
                .isDirty=${isDirty}
                .isReadOnly=${isElementReadOnly}
                .value=${value}
                .actions=${actions}
                .validationError=${validationError}></form-element-input>`;
        }
        if (typeof itemTemplate === 'object') {
            if (itemTemplate.hidden) {
                return null;
            }
            if (itemTemplate.type === OPTION_TYPES.STRING) {
                return html`<form-element-input
                    .path=${path}
                    .detailMode=${detailMode}
                    .isOverrideMode=${isOverrideMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isElementReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .validationError=${validationError}></form-element-input>`;
            }
            if (itemTemplate.type === OPTION_TYPES.BOOL) {
                return html`<form-element-checkbox
                    .path=${path}
                    .detailMode=${detailMode}
                    .isOverrideMode=${isOverrideMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isElementReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .validationError=${validationError}></form-element-checkbox>`;
            }
            // todo here RG
            if (
                itemTemplate.type === OPTION_TYPES.SELECT ||
                itemTemplate.type === OPTION_TYPES.MULTISELECT
            ) {
                return html`<form-element-select
                    .path=${path}
                    .detailMode=${detailMode}
                    .isOverrideMode=${isOverrideMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isElementReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .validationError=${validationError}></form-element-select>`;
            }
            if (itemTemplate.type === OPTION_TYPES.RADIO_GROUP) {
                return html`<form-element-radio-group
                    .path=${path}
                    .detailMode=${detailMode}
                    .isOverrideMode=${isOverrideMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isElementReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .validationError=${validationError}></form-element-radio-group>`;
            }
            if (itemTemplate.type === OPTION_TYPES.DOMAIN) {
                return html`<form-element-domain
                    .path=${path}
                    .detailMode=${detailMode}
                    .isOverrideMode=${isOverrideMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isElementReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .guid=${guid}
                    .validationError=${validationError}></form-element-domain>`;
            }
            if (itemTemplate.type === OPTION_TYPES.AUTH_CONTEXT) {
                return html`<form-element-auth-context
                    .path=${path}
                    .detailMode=${detailMode}
                    .isOverrideMode=${isOverrideMode}
                    .itemTemplate=${itemTemplate}
                    .hasPassedValidationCheck=${hasPassedValidationCheck}
                    .isDirty=${isDirty}
                    .isReadOnly=${isElementReadOnly}
                    .value=${value}
                    .actions=${actions}
                    .validationError=${validationError}></form-element-auth-context>`;
            }
            if (itemTemplate.type === OPTION_TYPES.LEAGUE_DATA) {
                if (sport === 'soccer') {
                    return html`<form-element-soccer-leagues
                        .path=${path}
                        .detailMode=${detailMode}
                        .isOverrideMode=${isOverrideMode}
                        .itemTemplate=${itemTemplate}
                        .hasPassedValidationCheck=${hasPassedValidationCheck}
                        .isDirty=${isDirty}
                        .isReadOnly=${isElementReadOnly}
                        .value=${value}
                        .actions=${actions}
                        .validationError=${validationError}></form-element-soccer-leagues>`;
                }
                if (sport === 'cricket') {
                    return html`<form-element-cricket-leagues
                        .path=${path}
                        .detailMode=${detailMode}
                        .isOverrideMode=${isOverrideMode}
                        .itemTemplate=${itemTemplate}
                        .hasPassedValidationCheck=${hasPassedValidationCheck}
                        .isDirty=${isDirty}
                        .isReadOnly=${isElementReadOnly}
                        .value=${value}
                        .actions=${actions}
                        .validationError=${validationError}></form-element-cricket-leagues>`;
                }
                if (sport === 'rugby') {
                    return html`<form-element-rugby-competitions
                        .path=${path}
                        .detailMode=${detailMode}
                        .isOverrideMode=${isOverrideMode}
                        .itemTemplate=${itemTemplate}
                        .hasPassedValidationCheck=${hasPassedValidationCheck}
                        .isDirty=${isDirty}
                        .isReadOnly=${isElementReadOnly}
                        .value=${value}
                        .actions=${actions}
                        .validationError=${validationError}></form-element-rugby-competitions>`;
                }
            }
        }
        return html`<p>${path}</p>`;
    }

    renderTooltip() {
        const { itemTemplate } = this;
        const { tooltip } = itemTemplate;
        if (!tooltip) {
            return null;
        }
        // return html`<span
        //     ><tmn-tooltip selector="tmn-icon">${tooltip}</tmn-tooltip
        //     ><tmn-icon class="info" icon="info" iconvariant="outlined"></tmn-icon
        // ></span>`;
        // return html`<tmn-tooltip selector=":first-child > :first-child" position="top"
        //     >${tooltip}</tmn-tooltip
        // >`;
    }

    renderOverrideDetail() {
        const { hasOverride, isOverrideMode } = this;
        if (!hasOverride) {
            return null;
        }

        if (this.isViewMode()) {
            return html`
                <tmn-tooltip selector="tmn-icon">${this.renderOvervideTooltipValue()}</tmn-tooltip>
                <tmn-icon class="info" icon="info" iconvariant="outlined"></tmn-icon>
            `;
        }
        return html`
            <tmn-icon-button variant="outlined" @click="${this.handleClearOverride}">
                <tmn-icon icon="clear" iconvariant="outlined"></tmn-icon>
            </tmn-icon-button>
            ${isOverrideMode
                ? null
                : html`<div>
                      <tmn-tooltip selector="tmn-icon"
                          >${this.renderOvervideTooltipValue()}</tmn-tooltip
                      >
                      <tmn-icon class="info" icon="info" iconvariant="outlined"></tmn-icon>
                  </div>`}
        `;
    }

    // may be some duplication here with the specific components, review if this gets out of hand
    renderOvervideTooltipValue() {
        const { overrideValue } = this;
        return html`<b>Staging override value: ${overrideValue}</b>`;
    }

    handleClearOverride() {
        this.actions.clearOverride(this.path);
    }
}

// just take path and get from factory
const mapStateToProps = (state, ownProps) => {
    const hasPassedValidationCheckSelector = selectors.sitePassedValidationSelectorFactory(
        ownProps.path
    );
    const overrideValueSelector = selectors.siteElementOverrideValueFactory(
        ownProps.path,
        ownProps.itemTemplate
    );
    const valueSelector = ownProps.isOverrideMode
        ? overrideValueSelector
        : selectors.siteElementValueFactory(ownProps.path, ownProps.itemTemplate);

    const hasOverrideSelector = selectors.siteElementHasOverrideFactory(
        ownProps.path,
        ownProps.itemTemplate
    );

    const isDirtySelector = selectors.siteElementIsDirtyFactory(
        ownProps.path,
        ownProps.itemTemplate
    );
    const isReadOnlySelector = selectors.siteElementIsReadOnlyFactory(
        ownProps.path,
        ownProps.itemTemplate
    );
    const errorMessageSelector = selectors.siteElementErrorFactory(ownProps.path);

    return (state) => {
        return {
            hasPassedValidationCheck: hasPassedValidationCheckSelector(state),
            value: valueSelector(state),
            isDirty: isDirtySelector(state),
            isReadOnly: isReadOnlySelector(state),
            detailMode: selectors.siteDetailModeSelector(state),
            hasOverride: hasOverrideSelector(state),
            overrideValue: overrideValueSelector(state),
            validationError: errorMessageSelector(state),
            guid: selectors.selectedSiteGuidSelector(state),
            sport: selectors.siteSportSelector(state),
        };
    };
};

customElements.define('form-element-site', connect(mapStateToProps, siteActions)(FormElementSite));
